import React from "react";
import { Row, Col } from "reactstrap";
import { TabPane } from "reactstrap";
import Image from "../../../components/Image";

const caseInfo = {
	source: "Shengwei Zhu",
};

export default function IndoorPresenter() {
	return (
		<TabPane tabId={"indoor-presenter"}>
			<Row style={{ padding: 16 }}>
				<Col xs="12" sm={{ size: 12 }}>
					<h4>Indoor Presenter</h4>
				</Col>

				<Col xs="12">
					<Row>
						<Col xs={12} sm={8}>
							<p>
								Using computational fluid dynamics and the Wells-Riley equation,
								the City@UMD team has analyzed the concentration of airborne
								COVID-19 particles in two indoor cases. Case 1 has both the
								supply and exhaust at the ceiling level, a typical ventilation
								system design. Case 2 has the supply at the ceiling and the
								exhaust at the floor. Both cases are simulated with an occupant,
								viral particulate source, in the center of the room. The cases
								differ solely in the placement of the space's HVAC supply and
								exhaust diffusers.
							</p>
							<p>
								The animation on the right shows the effectiveness of a
								push/pull localized air cleaning solution from the mouth of a
								presenter. This appears to be an effective solution for
								preventing airborne transmission of COVID-19 from an individual
								presenter who is either singing or speaking.
							</p>
						</Col>
						<Col xs={12} sm={4}>
							{/* <h5 className="text-center">
								Case 2: Ceiling Supply and Floor Exhaust
							</h5> */}
							<figure className="figure">
								<Image
									src={`images/covid/indoor/push_pull_cleaning.gif`}
									alt=""
								/>
								<figcaption className="figure-caption">
									Animation of push-pull individualzed air cleaning solution for
									indoor presenter.
								</figcaption>
								<figcaption className="figure-caption">
									Source: City@UMD [{caseInfo.source}]
								</figcaption>
							</figure>
						</Col>
					</Row>
				</Col>
				<Col xs="12" sm={{ size: 10, offset: 1 }}>
					<Row>
						<Col xs={12} sm={6}>
							<h5 className="text-center">
								Case 1: Supply and Exhaust at Ceiling
							</h5>
							<figure className="figure">
								<Image src={`images/covid/indoor1.gif`} alt="" />
								<figcaption className="figure-caption">
									Animation of exhaled particles of occupant in Case 1 over 60
									minutes.
								</figcaption>
								<figcaption className="figure-caption">
									Source: City@UMD [{caseInfo.source}]
								</figcaption>
							</figure>
						</Col>
						<Col xs={12} sm={6}>
							<h5 className="text-center">
								Case 2: Ceiling Supply and Floor Exhaust
							</h5>
							<figure className="figure">
								<Image src={`images/covid/indoor2.gif`} alt="" />
								<figcaption className="figure-caption">
									Animation of exhaled particles of occupant in Case 2 over 60
									minutes.
								</figcaption>
								<figcaption className="figure-caption">
									Source: City@UMD [{caseInfo.source}]
								</figcaption>
							</figure>
						</Col>
					</Row>
				</Col>
				<Col xs={12} sm={{ size: 12 }}>
					<p>
						<strong>
							Findings confirm the effectiveness of social distancing
						</strong>{" "}
						directives to keep <strong>2m/6ft</strong> apart as this is the
						boundary of the region around an infected person in which the risk
						of infection begins to rise steeply, especially with an{" "}
						<strong>exposure duration greater than 30 minutes</strong>. The
						simulations also show the variations in airborne particulate mixing
						due to different HVAC setups. Case 1, more common layout of supply
						and exhaust air in commercial buildings is less effective at
						removing COVID-19 particles yielding a larger and more persistent
						region of high COVID-19 infection risk. Please, note how the Case 1
						animation shows a more widely dispersed particles at the end of the
						animation.
					</p>
				</Col>
				<Col xs="12" sm={{ size: 10, offset: 1 }}>
					<Row>
						<Col xs={12} sm={6}>
							<h5 className="text-center">
								Case 3: Presenter with Face covering
							</h5>
							<figure className="figure">
								<Image src={`images/covid/indoor/indoor_withmask.gif`} alt="" />
								<figcaption className="figure-caption">
									Animation of exhaled particles of occupant{" "}
									<strong>wearing face covering</strong>.
								</figcaption>
								<figcaption className="figure-caption">
									Source: City@UMD [{caseInfo.source}]
								</figcaption>
							</figure>
						</Col>
						<Col xs={12} sm={6}>
							<h5 className="text-center">
								Case 4: Presenter without Face Covering
							</h5>
							<figure className="figure">
								<Image src={`images/covid/indoor/indoor_nomask.gif`} alt="" />
								<figcaption className="figure-caption">
									Animation of exhaled particles of occupant{" "}
									<strong>not wearing face covering</strong>.
								</figcaption>
								<figcaption className="figure-caption">
									Source: City@UMD [{caseInfo.source}]
								</figcaption>
							</figure>
						</Col>
					</Row>
				</Col>
				<Col xs={12} sm={{ size: 12 }}>
					<p>
						Modeling efforts shown in Cases 3 & 4 for indoor presenters show the
						effects that wearing a mask (face covering) has on the spread of an
						infected persons aerosols in an indoor space.
					</p>
					<p>
						The wearing of a face covering both limits the dispursal of the
						exhaled viral quanta and increases the duration that viral aerosols
						take to travel in indoor spaces; this difference in time is critical
						for the HVAC system to safely dilute and remove the aerosolized
						virus.
					</p>
				</Col>
			</Row>
		</TabPane>
	);
}
